import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { toJS } from 'mobx'
import {
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBBtn,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import ACMStore from './../AgentContractManager.store'
import UserProfileService from './../../../shared/services/UserProfile.service'
import { UserContractRequestFactory } from './../../../shared/factories'
import moment from 'moment'

import './AcknowledgeContractRequestsModal.scss'

const AcknowledgeContractRequestsModal = ({ onCheckingOutToggle }) => {
  const Carriers = toJS(ACMStore.Carriers)
  const carriersLoaded = Carriers.length > 0
  const userId = UserProfileService.get('id')
  const [isOpen, setIsOpen] = useState(false)
  const [acknowledgeableRequests, setAcknowledgeableRequests] = useState(null)

  const getAcknowledgeableRequests = async () => {
    // 1. get all user contract requests.
    const User = await UserProfileService.instance(),
      AllContractRequests = await User.contractRequest().all()
    ACMStore.add('ContractRequest', AllContractRequests)

    // 2. filter down to the requests that are expired & not acknowledged.
    const ContractRequests = toJS(AllContractRequests).filter(
      Request => Request.get('is_expired') && !Request.get('acknowledged_at')
    )

    // 3. attach the carrier instance to the contract request.
    const acknowledgeableRequests = ContractRequests.map(R => {
      R.carrier = Carriers.find(C => {
        return Array.isArray(C) ? C.find(I => I.id() == R.get('carrier_id')) : C.id() == R.get('carrier_id')
      })
      return R
    })

    return acknowledgeableRequests
  }

  const renderTable = () => {
    if (acknowledgeableRequests)
      return (
        <ul>
          {acknowledgeableRequests.map(cr => (
            <li key={`cr-${cr.id()}-${cr.get('carrier_id')}`}>{cr?.carrier?.get('c_name') || cr.get('carrier_id')}</li>
          ))}
        </ul>
      )
    return <ul></ul>
  }

  const acknowledge = async () => {
    setIsOpen(false)

    await Promise.all(
      acknowledgeableRequests.map(req => {
        req.set('acknowledged_at', moment().utc().format('YYYY-MM-DD HH:mm:ss'))
        return req.save()
      })
    )

    getAcknowledgeableRequests().then(req => setAcknowledgeableRequests(req))
  }

  useEffect(() => {
    if (userId && carriersLoaded) {
      getAcknowledgeableRequests().then(req => {
        setAcknowledgeableRequests(req)
        setIsOpen(!!req.length)
      })
    }
  }, [userId, carriersLoaded])

  return (
    <MDBModal open={isOpen} onClose={() => acknowledge()} className='contract-request-modal'>
      <MDBModalDialog>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>Carrier Contract Requests</MDBModalTitle>
            <MDBBtn type='button' className='btn-close' color='none' onClick={() => acknowledge()}></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>
            <h6>Great News!</h6>
            <p>You can now contract with these carriers from your Contracting Requests.</p>
            {renderTable()}
            <br />
            <MDBBtn type='button' block size='sm' color='success' onClick={() => acknowledge()}>
              Close
            </MDBBtn>
          </MDBModalBody>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  )
}

export default observer(AcknowledgeContractRequestsModal)
